module.exports = __webpack_public_path__ + "static/media/farmers_list.07331486.png";